import { AutoCompleteModule } from 'primeng/autocomplete';
import { ToastModule } from 'primeng/toast';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule, TransferState } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MissingTranslationHandler,
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { SelectButtonModule } from 'primeng/selectbutton';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { LoadMaskComponent } from './load-mask/load-mask.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { I18nLabelPipe } from './i18n-label.pipe';
import { FieldStateMarkerComponent } from './field-state-marker/field-state-marker.component';
import { I18nMessagePipe } from './i18n-message.pipe';
import { CKEditorModule } from 'ng2-ckeditor';
import { DateRangePickerComponent } from './date-range-picker/date-range-picker.component';
import { DropdownModule } from 'primeng/dropdown';
import { TabViewModule } from 'primeng/tabview';
import { TabMenuModule } from 'primeng/tabmenu';
import { MoneyInputComponent } from './money-input/money-input.component';
import { ThreadViewComponent } from './comments/thread-view/thread-view.component';
import { ThreadPostEditorComponent } from './comments/thread-post-editor/thread-post-editor.component';
import { LocationPickerComponent } from './location-picker/location-picker.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { SafeHtmlPipe } from './safe-html.pipe';
import { RejectDialog } from './reject-popup/reject-dialog.component';
import { MonthToYearsPipe } from './month-to-year-with-month';
import { NumberToMonthPipe } from './number-to-month';
import { GenderPipe } from './gender.pipe';
import { translateBrowserLoaderFactory } from './translate-browser.loader';
import { HttpClient } from '@angular/common/http';
import { HrMissingTranslationHandler } from '../missing-translation-handler';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DatePicker } from 'primeng/datepicker';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CKEditorModule,
    DialogModule,
    TableModule,
    MatAutocompleteModule,
    MatInputModule,
    MatFormFieldModule,
    DatePicker,
    TranslateModule,
    ButtonModule,
    CheckboxModule,
  ],
  declarations: [
    LoadMaskComponent,
    RejectDialog,
    NotFoundComponent,
    I18nLabelPipe,
    GenderPipe,
    SafeHtmlPipe,
    FieldStateMarkerComponent,
    I18nMessagePipe,
    DateRangePickerComponent,
    MoneyInputComponent,
    ThreadViewComponent,
    ThreadPostEditorComponent,
    LocationPickerComponent,
    NumberToMonthPipe,
    MonthToYearsPipe,
  ],
  exports: [
    LoadMaskComponent,
    TranslateModule,
    ToastModule,
    I18nLabelPipe,
    SafeHtmlPipe,
    I18nMessagePipe,
    NumberToMonthPipe,
    MonthToYearsPipe,
    FormsModule,
    CommonModule,
    FieldStateMarkerComponent,
    DateRangePickerComponent,
    MoneyInputComponent,
    CKEditorModule,
    TableModule,
    DialogModule,
    OverlayPanelModule,
    SelectButtonModule,
    DropdownModule,
    AutoCompleteModule,
    TabViewModule,
    TabMenuModule,
    ThreadViewComponent,
    ThreadPostEditorComponent,
    GenderPipe,
    LocationPickerComponent,
    RejectDialog,
    ButtonModule,
    ReactiveFormsModule,
    CheckboxModule,
  ],
})
export class SharedModule {}
